import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import OTP from "./pages/OTP";
import Dashboard from "./pages/Dashboard";
import { NavigationProvider } from "./context/NavigationContext";
import AddNewDriver from "./pages/AddNewDriver";
import Drivers from "./pages/Drivers";
import DriverDetails from "./pages/DriverDetails";
import Riders from "./pages/Riders";
import RiderDetails from "./pages/RiderDetails";
import PaymentsEarnings from "./pages/PaymentsEarnings";
import Settings from "./pages/Settings";
import AddNewAdmin from "./pages/AddNewAdmin";
import FleetManagement from "./pages/FleetManagement";
import Trips from "./pages/Trips";
import Pricing from "./pages/Pricing";
import Withdrawals from "./pages/Withdrawals";
import DeletionRequests from "./pages/DeletionRequests";
import RiderPerformance from "./pages/RiderPerformance";
import Promotions from "./pages/Promotions";
import AdminManagement from "./pages/AdminManagement";
import NotificationDelivery from "./pages/NotificationDelivery";
import TripInspector from "./pages/TripInspector";
import ServiceAreas from "./pages/ServiceAreas";
import AdminRideAlerts from "./components/AdminRideAlerts";
import EnvironmentBanner from "./components/EnvironmentBanner";
import { useTheme } from "./context/ThemeContext";
import { useEffect } from "react";
import RiderRewards from "./pages/RiderRewards";
import Ratings from "./pages/Ratings";

function App() {
  const { theme } = useTheme();

  // Apply theme class to the root element
  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  return (
    <div className={`min-h-screen bg-white text-primary transition-colors duration-200 ${theme}`}>
      <EnvironmentBanner />
      <NavigationProvider>
        <AdminRideAlerts />
        <Routes>
          <Route path="/" element={<Login />} />
          {/* The 401 interceptor + OTP redirect to /login, so it must render the
              Login page (previously there was no such route → blank screen). */}
          <Route path="/login" element={<Login />} />
          <Route path="/otp" element={<OTP />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/drivers" element={<Drivers />} />
          <Route path="/drivers/add" element={<AddNewDriver />} />
          <Route path="/drivers/edit/:id" element={<AddNewDriver isEditMode={true} />} />
          <Route path="/driver-details/:id" element={<DriverDetails />} />
          <Route path="/riders" element={<Riders />} />
          <Route path="/rider-details/:id" element={<RiderDetails />} />
          <Route path="/payments" element={<PaymentsEarnings />} />
          <Route path="/withdrawals" element={<Withdrawals />} />
          <Route path="/deletion-requests" element={<DeletionRequests />} />
          <Route path="/rider-performance" element={<RiderPerformance />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/rider-rewards" element={<RiderRewards />} />
          <Route path="/ratings" element={<Ratings />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/settings/add-admin" element={<AddNewAdmin />} />
          <Route path="/admins" element={<AdminManagement />} />
          <Route path="/push-delivery" element={<NotificationDelivery />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/trip-inspector" element={<TripInspector />} />
          <Route path="/trip-inspector/:bookingId" element={<TripInspector />} />
          <Route path="/fleet" element={<FleetManagement />} />
          <Route path="/trips" element={<Trips />} />
          {/* Any unknown path falls back to the login page instead of a blank screen. */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </NavigationProvider>
    </div>
  );
}

export default App;